'use client'

import { useEffect, useMemo } from 'react'

import { type UdpTrackingProductImpression } from './model/udpTrackingTypes'
import {
  type UdpTrackingVisibilityTracker,
  udpTrackingVisibilityTrackerCreate,
} from './udpTrackingVisibilityTracker'

export const useUdpTrackingVisibilityTracker = ({
  onVisible,
}: {
  onVisible: (impressions: UdpTrackingProductImpression[]) => void
}): UdpTrackingVisibilityTracker<UdpTrackingProductImpression> => {
  const tracker = useMemo(
    () => udpTrackingVisibilityTrackerCreate<UdpTrackingProductImpression>(),
    [],
  )

  useEffect(() => {
    tracker.setOnVisible(onVisible)
  }, [onVisible, tracker])

  useEffect(
    () => (): void => {
      tracker.reset()
    },
    [tracker],
  )

  return tracker
}
